import vue from 'vue'
import Confirm from './Confirm'

const ConfirmConstructor = vue.extend(Confirm)
function showConfirm(object = {}) {
  const confirmDom = new ConfirmConstructor({
    el: document.createElement('div'),
    data() {
      return {
        haveCancel: object.haveCancel,
        modalTitle: object.title || '标题',
        modalButtonOk: object.okText || '确定',
        modalButtonCancel: object.cancelText || '取消',
        ok: () => {
          document.body.removeChild(confirmDom.$el)
          object.ok ? object.ok() : ''
        },
        cancel: () => {
          document.body.removeChild(confirmDom.$el)
          object.cancel ? object.cancel() : ''
        }
      }
    }
  })
  document.body.appendChild(confirmDom.$el)
}
function registerConfirm() {
  vue.prototype.$confirm = showConfirm
}
export default registerConfirm



// WEBPACK FOOTER //
// ./src/components/Confirm/index.js